import ROLE from "models/role";
import { ADMIN_ROUTES } from "definitions/constants/routeConstants";
import AdminCompaniesPage from "pages/Admin/CompaniesPage";
import AdminCompanyPage from "pages/Admin/CompaniesPage/show";
import AdminCalendarPage from "pages/Admin/CalendarPage";
import AdminDesignSystemPage from "pages/Admin/DesignSystemPage";
import AdminCustomInputsPage from "pages/Admin/CustomInputsPage";
import AdminUsersPage from "pages/Admin/UsersPage";
import AdminHubPage from "pages/Admin/HubPage";
import AdminEmailConfigurationPage from "pages/Admin/CompaniesPage/EmailConfigurationPage";
import FloatingFieldMdPage from "pages/Examples/FloatingFieldMdPage";
import FloatingFieldSmPage from "pages/Examples/FloatingFieldSmPage";
import { Route } from "./types";

const CAMINO_TEAM_ROUTES_PERMISSIONS = {
  permission: [ROLE.CAMINO_TEAM],
};

const ADMIN_HUB_ROUTE: Route = {
  path: ADMIN_ROUTES.hub,
  title: "Admin Hub",
  component: <AdminHubPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const ADMIN_COMPANY_ROUTE: Route = {
  path: ADMIN_ROUTES.companies.show,
  title: "Company",
  component: <AdminCompanyPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const ADMIN_COMPANY_EMAIL_CONFIGURATION_ROUTE: Route = {
  path: ADMIN_ROUTES.companies.emailConfiguration.index,
  title: "Email Configuration",
  component: <AdminEmailConfigurationPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const ADMIN_COMPANIES_ROUTE: Route = {
  path: ADMIN_ROUTES.companies.index,
  title: "Manage Companies",
  component: <AdminCompaniesPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const ADMIN_MANAGE_USERS_ROUTE: Route = {
  path: ADMIN_ROUTES.users.index,
  title: "Manage Users",
  component: <AdminUsersPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const ADMIN_CALENDAR_ROUTE: Route = {
  path: ADMIN_ROUTES.calendarTest,
  title: "Calendar Test",
  component: <AdminCalendarPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const ADMIN_DESIGN_SYSTEM_ROUTE: Route = {
  path: ADMIN_ROUTES.designSystem,
  title: "Design System",
  component: <AdminDesignSystemPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const ADMIN_CUSTOM_INPUTS_ROUTE: Route = {
  path: ADMIN_ROUTES.customInputs,
  title: "Custom Inputs",
  component: <AdminCustomInputsPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const EXAMPLE_FLOATING_MD_ROUTE: Route = {
  path: ADMIN_ROUTES.examples.floatingMd,
  title: "FloatingField MD",
  component: <FloatingFieldMdPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

const EXAMPLE_FLOATING_SM_ROUTE: Route = {
  path: ADMIN_ROUTES.examples.floatingSm,
  title: "FloatingField SM",
  component: <FloatingFieldSmPage />,
  ...CAMINO_TEAM_ROUTES_PERMISSIONS,
};

export default [
  ADMIN_HUB_ROUTE,
  ADMIN_CALENDAR_ROUTE,
  ADMIN_DESIGN_SYSTEM_ROUTE,
  ADMIN_CUSTOM_INPUTS_ROUTE,
  ADMIN_COMPANY_ROUTE,
  ADMIN_COMPANIES_ROUTE,
  ADMIN_MANAGE_USERS_ROUTE,
  ADMIN_COMPANY_EMAIL_CONFIGURATION_ROUTE,
  EXAMPLE_FLOATING_MD_ROUTE,
  EXAMPLE_FLOATING_SM_ROUTE,
];
